import { defaults } from 'lodash';
import {
  APPS_MAX_HEIGHT,
  APPS_MAX_WIDTH,
  APPS_MIN_HEIGHT,
  APPS_MIN_WIDTH,
  REMOTE_VIDEO_DEFAULT_HEIGHT,
  REMOTE_VIDEO_DEFAULT_WIDTH,
} from '../../iframe/additional-apps.utils';
import { FrameItem } from '../../../../models/session';
import { VideoTrackType } from '../../../../services/session-call-tracks.service';
import { BoardItemConfig, CreationContext } from './board-item-configurations';

export class BoardRemoteVideoConfigurations extends BoardItemConfig {
  participantId: string;
  trackType: VideoTrackType;

  static defaultBoardItemConfigurations: Partial<BoardItemConfig> = {
    width: REMOTE_VIDEO_DEFAULT_WIDTH,
    height: REMOTE_VIDEO_DEFAULT_HEIGHT,
    minWidth: APPS_MIN_WIDTH,
    maxWidth: APPS_MAX_WIDTH,
    minHeight: APPS_MIN_HEIGHT,
    maxHeight: APPS_MAX_HEIGHT,
  };

  constructor(
    configurations: Partial<BoardRemoteVideoConfigurations> & Partial<BoardItemConfig>,
    globalCreationParams: CreationContext,
  ) {
    super(
      {
        ...BoardRemoteVideoConfigurations.defaultBoardItemConfigurations,
        ...configurations,
      },
      globalCreationParams,
    );

    const defaultVideoConfigurations = {
      participantId: '',
      trackType: '',
    };

    const videoConfigurations = defaults(configurations, defaultVideoConfigurations);

    this.participantId = videoConfigurations.participantId;
    this.trackType = videoConfigurations.trackType;
  }

  static fromYCanvasItemObject(
    frameItem: FrameItem,
    globalCreationsParams: CreationContext,
  ): BoardRemoteVideoConfigurations {
    const configurations = BoardItemConfig.fromYCanvasItemObject(
      frameItem,
      globalCreationsParams,
      BoardRemoteVideoConfigurations.defaultBoardItemConfigurations,
    );

    // The contentId format is "participantId:trackType"
    const [participantId = '', trackType = ''] = frameItem.content_id?.split(':') || [];

    return new BoardRemoteVideoConfigurations(
      {
        ...configurations,
        participantId,
        trackType: trackType as VideoTrackType,
      },
      globalCreationsParams,
    );
  }
}
